import React from 'react';

const CloseIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <circle
      id="circle"
      fill="#CFDAE1"
      transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) "
      cx="8"
      cy="8"
      r="8"
    />
    <path
      d="M7.97487373,7.26776695 L10.0961941,5.14644661 C10.2914562,4.95118446 10.6080387,4.95118446 10.8033009,5.14644661 C10.998563,5.34170876 10.998563,5.65829124 10.8033009,5.85355339 L8.68198052,7.97487373 L10.8033009,10.0961941 C10.998563,10.2914562 10.998563,10.6080387 10.8033009,10.8033009 C10.6080387,10.998563 10.2914562,10.998563 10.0961941,10.8033009 L7.97487373,8.68198052 L5.85355339,10.8033009 C5.65829124,10.998563 5.34170876,10.998563 5.14644661,10.8033009 C4.95118446,10.6080387 4.95118446,10.2914562 5.14644661,10.0961941 L7.26776695,7.97487373 L5.14644661,5.85355339 C4.95118446,5.65829124 4.95118446,5.34170876 5.14644661,5.14644661 C5.34170876,4.95118446 5.65829124,4.95118446 5.85355339,5.14644661 L7.97487373,7.26776695 Z"
      id="clean"
      stroke="#FFFFFF"
      strokeWidth="0.5"
      fill="#FFFFFF"
    />
  </svg>
);

export default CloseIcon;
